__turbopack_context__.v({
  "copyLinkButton": "SharingOptions-module__6UnvqW__copyLinkButton",
  "copyLinkSuccessText": "SharingOptions-module__6UnvqW__copyLinkSuccessText",
  "linkBox": "SharingOptions-module__6UnvqW__linkBox",
  "linkText": "SharingOptions-module__6UnvqW__linkText",
  "shareOptionsButton": "SharingOptions-module__6UnvqW__shareOptionsButton",
  "shareOptionsContainer": "SharingOptions-module__6UnvqW__shareOptionsContainer",
  "shareOptionsForm": "SharingOptions-module__6UnvqW__shareOptionsForm",
});
